/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNeighborhoodsVisibilityPauseStatusRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetNeighborhoodsVisibilityPauseStatusResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getNeighborhoodsVisibilityPauseStatus = (request: GetNeighborhoodsVisibilityPauseStatusRequest, options?: CashRequestOptions) => post<GetNeighborhoodsVisibilityPauseStatusRequest, GetNeighborhoodsVisibilityPauseStatusResponse>("/2.0/cash/get-neighborhoods-visibility-pause-status", request, {...options, rejectOnError: true })